import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "DD",
  "Discontinued": "Přerušeno",
  "Spare part list": "Seznam náhradních dílů",
  "Download Excel": "Stáhnout Excel",
  "Recent search list": "Seznam posledních vyhledávání",
  "No data": "Pro zadané parametry vyhledávání nejsou k dispozici žádná data",
  "spare part": "náhradní díl",
  "none": "Žádné",
  "no value": "žádná hodnota",
  "No results found": "Nebyly nalezeny žádné výsledky",
  "Spare parts for": "Náhradní díly pro",
  "Could not load cumulated data": "Nelze načíst kumulovaná data",
  "commissioning part": "uvedení do provozu",
  "wear part": "opotřebitelný díl",
  "Search": "Vyhledávání",
  "Tk": "Tk",
  "Spare part number": "Číslo náhradního dílu",
  "drawing": "kreslení",
  "Products for": "Produkty pro",
  "Available": "Dostupné na",
  "MM": "MM",
  "The entered order code is invalid": "Zadaný kód objednávky je neplatný",
  "Recommended": "Doporučené stránky",
  "No data available for the entered search parameters": "Pro zadané parametry vyhledávání nejsou k dispozici žádná data",
  "Search spare parts": "Vyhledávání náhradních dílů",
  "Order code / product root / serial number": "Objednací kód / kořen produktu / sériové číslo",
  "Characteristic": "Charakteristika",
  "Please enter an order code": "Zadejte prosím kód objednávky",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "Z hlediska kvality a bezpečnosti společnost Endress+Hauser důrazně doporučuje používat výhradně originální náhradní díly Endress+Hauser. \nÚdržbu a opravy přístroje smí provádět pouze kvalifikovaný personál. \nJe třeba dodržovat platné normy a zákonné požadavky, jakož i případné certifikáty!",
  "Maintenance advice": "Poradenství v oblasti údržby",
  "Mo.": "Mo.",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "Pro jaký výrobek (výrobky) lze použít můj náhradní díl? \nPři vyplnění objednacího kódu náhradního dílu (např. 71002865 nebo XPD0024) se zobrazí příslušná zařízení, ve kterých lze tento náhradní díl použít.",
  "tool": "nástroj",
  "Production numbers": "Výrobní čísla",
  "New alternative": "Nová alternativa",
  "There are no items selected. Please use the checkboxes to make your selection": "Varování",
  "Service segmentation": "Segmentace služeb",
  "Seg": "Seg",
  "Valid": "Platí",
  "Pos": "Pozice",
  "Value": "Hodnota",
  "service segmentation 2": "Části, které vyžadují základní znalosti. Předpokladem je úspěšná účast na základním školení E+H.",
  "Phase out date": "Datum ukončení",
  "service segmentation 1": "Části, které vyžadují základní znalosti.",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "Které náhradní díly jsou pro můj výrobek k dispozici? \nPři zadání objednacího kódu (např. FTC260-AA2A1 nebo PMC51-BA21JB1CGBTDJB) nebo ID výrobku (např. FTC260 nebo 83F50) se zobrazí příslušné náhradní díly.",
  "Set filter": "Nastavení filtru",
  "Search date": "Datum vyhledávání",
  "Group": "Skupina",
  "Warning": "Nejsou vybrány žádné položky. Výběr proveďte pomocí zaškrtávacích políček.",
  "Description": "Popis",
  "Cancel": "Zrušit",
  "service segmentation 4": "Díly pro opravu ve výrobním závodě. Odborné znalosti jsou povinné.",
  "service segmentation 3": "Části, které vyžadují specializované znalosti. Předpokladem je úspěšná účast na pokročilém školení E+H.",
  "Drawing Position Number": "Číslo pozice výkresu",
  "Spare parts search": "Vyhledávání náhradních dílů",
  "Confirm": "Potvrďte",
  "Ordercode too short": "Příliš krátký objednací kód",
  "Product status": "Stav produktu",
  "Open": "Otevřít",
  "Clear": "Přehledně",
  "PDF file with assembly instructions": "Soubor PDF s návodem k montáži",
  "Search products": "Vyhledávání produktů",
  "Export": "Export",
  "Production date": "Datum výroby",
  "Order stop": "Zastavení objednávky",
  "Calibration until": "Kalibrace do",
  "PDF file with compatibility information": "Soubor PDF s informacemi o kompatibilitě",
  "Add selection to cart": "Přidat výběr do košíku",
  "Mounting advices": "Rady pro montáž",
  "Recommended parts only": "Pouze doporučené díly",
  "not applicable": "otevřít",
  "accessories": "příslušenství",
  "Cumulative spare parts list": "Kumulativní seznam náhradních dílů",
  "YYYY": "RRRR",
  "Title": "Název",
  "Error": "Chyba",
  "Ordercode too long": "Příliš dlouhý objednací kód",
  "Functions": "Funkce",
  "Rec": "Rec",
  "Type": "Typ",
  "Spare sensor until": "Náhradní snímač do",
  "Spare parts until": "Náhradní díly do",
  "Filter": "Filtr",
  "Check all": "Zkontrolujte všechny",
  "Order code": "Objednací kód",
  "Repair until": "Oprava do",
  "Tag": "Štítek",
  "Ok": "Ok",
  "Category code": "Kód kategorie",
  "Phase out": "Postupné ukončování",
  'Compatibility advices': 'Doplňkové dokumenty',
  'Co.': 'Dopl. dok.',
} as LocalizedDictionary;
